import { readResidentListSessionFilter } from './residentSessionFilter'

/** Angular `routeParams` / `filterForm.patchValue({ q })` — prefer URL, then session. */
export function readResidentListHandoffSearchFromLocation(
  search?: string,
): string {
  if (typeof window !== 'undefined') {
    const fromUrl = new URLSearchParams(
      search ?? window.location.search,
    )
      .get('applicant_id')
      ?.trim()
    if (fromUrl) return fromUrl
  }
  return String(readResidentListSessionFilter().q ?? '').trim()
}
